import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";
import "react-toastify/dist/ReactToastify.css";

const marketplaceIcon = "/win/images/marketplace.png";

const Benefits_WinMarketPlace = () => {
  const contract = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const token = localStorage.getItem("AccessToken");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [marketplaceItems, setMarketplaceItems] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchMarketplaceItems = async () => {
      setLoading(true);
      setError("");

      const params = {
        Email: contract?.userData?.EmailID || "",
        Language: contract?.userData?.Language || "English",
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        Contract: contract?.userData?.ContractIdentified || "",
      };

      try {
        const response = await axios.post(
          Endpoints.LoadMarketPlace,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const items = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
            ? response.data.data
            : Array.isArray(response.data?.MarketPlace)
              ? response.data.MarketPlace
              : [];

        setMarketplaceItems(items);
      } catch (err) {
        setError("Failed to load marketplace items.");
      } finally {
        setLoading(false);
      }
    };

    if (contract?.userData?.EmailID && token) {
      fetchMarketplaceItems();
    } else {
      setMarketplaceItems([]);
      setLoading(false);
    }
  }, [contract?.userData?.ContractIdentified, contract?.userData?.EmailID, contract?.userData?.Language, token]);

  const handleBackClick = () => {
    navigate("/home");
  };

  const handleMarketplaceDetailClick = (marketplaceItem) => {
    navigate("/winmarketplace-info", {
      state: {
        from: "/benefits-winmarketplace",
        marketplaceItem,
      },
    });
  };

  const getTags = (tags) => {
    if (Array.isArray(tags)) {
      return tags.filter(Boolean);
    }

    if (typeof tags === "string") {
      return tags
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
    }

    return [];
  };

  const stripHtml = (value) => {
    if (!value) {
      return "";
    }

    return value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  };

  const getEmployerCoveredClassName = (employerCovered) => {
    const normalizedEmployerCovered = employerCovered?.trim().toLowerCase();

    if (normalizedEmployerCovered === "yes") {
      return "employer-covered-pink";
    }

    if (normalizedEmployerCovered === "no") {
      return "employer-covered-yellow";
    }

    return "employer-covered-bordered";
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  if (error || marketplaceItems.length === 0) {
    return (
      <div
        className="col-12 d-flex align-items-center justify-content-center"
        style={{ minHeight: "60vh", textAlign: "center" }}
      >
        <p className="no-data-available mb-0">
          {"No marketplaces are available at the moment. Please try again later."}
        </p>
      </div>
    );
  }

  return (
    <>
    <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
        <h2 className="page-heading">{isHighmarkPortal ? "Fertility and Family Building Marketplace" : t("winmarketplace")}</h2>
      </div>
      <div className="col-12 col-md-12 mt-0 mb-5 marketplace-page">        
        <div className="marketplace-header d-flex d-lg-none flex-column gap-2 align-items-center">
          <img src={marketplaceIcon} alt="WIN Marketplace" className="image" />
          <h3>{ isHighmarkPortal ? "Fertility and Family Building Marketplace" : "WIN Marketplace"}</h3>
        </div>
        <div className="marketplace-grid">
          {marketplaceItems.map((item, index) => (
            <div
              key={index}
              className="marketplace-card"
              role="button"
              tabIndex={0}
            >
              <div className="image-wrapper">
                {item.ImagePath ? (
                  <img
                    src={item.ImagePath}
                    className="image"
                    alt={item.Title}
                  />
                ) : (
                  <img
                    src={marketplaceIcon}
                    className="image"
                    alt={item.Title || "WIN Marketplace"}
                  />
                )}
              </div>
              { item?.EmployerCoveredText && <div className={`mb-4 text-center ${getEmployerCoveredClassName(item?.EmployerCovered)}`}>
                 <div dangerouslySetInnerHTML={{ __html: item.EmployerCoveredText }}  />
                </div>}
              <h5 className="title mb-5">{item.Header}</h5>
              
              <p className="description">
                {stripHtml(item.Body)}                
              </p>

              <button
                  type="button"
                  className="win-btn-secondary-w-100 marketplace-detail-order-button mb-3"
                  onClick={() => handleMarketplaceDetailClick(item)}
                >
                  Learn More &gt;
                </button>
              <div className="tags">
                {getTags(item.Tags).map((tag) => ( 
                  <div key={tag} className="tag">
                    {tag}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Benefits_WinMarketPlace;
